import {
  createFrontendModule,
  coreExtensionData,
} from '@backstage/frontend-plugin-api';
import catalogGraphPlugin from '@backstage/plugin-catalog-graph/alpha';
import { makeStyles } from '@material-ui/core/styles';

const useCatalogGraphPageStyles = makeStyles(theme => ({
  root: {
    '& [class*="BackstageSelect-root"] [class*="MuiSelect-root"]': {
      backgroundColor: 'transparent',
    },

    '& [class*="MuiPaper-root"]': {
      backgroundColor: 'transparent',
      background: 'transparent',
      boxShadow: 'none',
    },

    '& [class*="MuiChip-root"]': {
      backgroundColor: '#1976D2',
      color: '#FFFFFF',
      fontWeight: 500,
      transition: theme.transitions.create(['background-color'], {
        duration: theme.transitions.duration.shorter,
      }),
      '&:hover': {
        backgroundColor: '#1565C0',
      },
      '&:focus': {
        backgroundColor: '#0D47A1',
      },
      '& [class*="MuiChip-label"]': {
        color: '#FFFFFF',
        fontWeight: 500,
      },
      '& [class*="MuiChip-deleteIcon"]': {
        color: '#FFFFFF',
        opacity: 0.9,
        '&:hover': {
          color: '#FFFFFF',
          opacity: 1,
          backgroundColor: '#0D47A1',
          borderRadius: '50%',
        },
      },
    },
  },
}));

const appviaCatalogGraphPage = catalogGraphPlugin
  .getExtension('page:catalog-graph')
  .override({
    factory(originalFactory, _context) {
      const originalContainer = originalFactory();
      const originalElement = originalContainer.get(
        coreExtensionData.reactElement,
      );

      const WrappedCatalogGraphPage = () => {
        const classes = useCatalogGraphPageStyles();
        return <div className={classes.root}>{originalElement}</div>;
      };

      return [
        coreExtensionData.reactElement(<WrappedCatalogGraphPage />),
        ...Array.from(originalContainer).filter(
          item => item.id !== 'core.reactElement',
        ),
      ];
    },
  });

export const appviaCatalogGraphModule = createFrontendModule({
  pluginId: 'catalog-graph',
  extensions: [appviaCatalogGraphPage],
});
